module.exports = __webpack_public_path__ + "static/STG20_Desktop_2880_Module5_Drink5_Spritz-d05ded477251a5398bac03381c90ae2a.png";